import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HosPalTaskStatusEnum {
    NotYetDue = 1,
    NotStarted = 2,
    Saved = 3,
    SubmittedCoSignature = 4,
    SubmittedWithSignature = 5, // Also known as pending QA
    ExportReady = 6,
    Exported = 7,
    ToBeSent = 8,
    SentToPhysician = 9,
    ReturnedWithPhysicianSignature = 10,
    Completed = 11,
    Returned = 12,
    Reopened = 13,
    NotExported = 14,
    Created = 15,
    PendingAddendum = 16,
    ProcessingSubmission = 17,
    OrderReceived = 18,
    Errored = 19,
    NotYetScheduled = 20
}

export class HosPalTaskStatusEnumClass extends EnumWithDescription<HosPalTaskStatusEnum> {
    public readonly enum = HosPalTaskStatusEnum;
    public readonly enumName: string = "HosPalTaskStatus";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HosPalTaskStatusEnum>> = new Map([
        [
            "NotYetDue",
            {
                value: HosPalTaskStatusEnum.NotYetDue,
                name: "Not Yet Due"
            }
        ],
        [
            "NotStarted",
            {
                value: HosPalTaskStatusEnum.NotStarted,
                name: "Not Yet Started"
            }
        ],
        [
            "Saved",
            {
                value: HosPalTaskStatusEnum.Saved,
                name: "Saved"
            }
        ],
        [
            "SubmittedCoSignature",
            {
                value: HosPalTaskStatusEnum.SubmittedCoSignature,
                name: "Submitted Pending Co-Signature"
            }
        ],
        [
            "SubmittedWithSignature",
            {
                value: HosPalTaskStatusEnum.SubmittedWithSignature,
                name: "Submitted with Signature"
            }
        ],
        [
            "ExportReady",
            {
                value: HosPalTaskStatusEnum.ExportReady,
                name: "Export Ready"
            }
        ],
        [
            "Exported",
            {
                value: HosPalTaskStatusEnum.Exported,
                name: "Export Ready"
            }
        ],
        [
            "ToBeSent",
            {
                value: HosPalTaskStatusEnum.ToBeSent,
                name: "To Be Sent"
            }
        ],
        [
            "SentToPhysician",
            {
                value: HosPalTaskStatusEnum.SentToPhysician,
                name: "Sent to Physician"
            }
        ],
        [
            "ReturnedWithPhysicianSignature",
            {
                value: HosPalTaskStatusEnum.ReturnedWithPhysicianSignature,
                name: "Returned with Physician Signature"
            }
        ],
        [
            "Completed",
            {
                value: HosPalTaskStatusEnum.Completed,
                name: "Completed"
            }
        ],
        [
            "Returned",
            {
                value: HosPalTaskStatusEnum.Returned,
                name: "Returned for Review"
            }
        ],
        [
            "Reopened",
            {
                value: HosPalTaskStatusEnum.Reopened,
                name: "Reopened"
            }
        ],
        [
            "NotExported",
            {
                value: HosPalTaskStatusEnum.NotExported,
                name: "Not Exported"
            }
        ],
        [
            "Created",
            {
                value: HosPalTaskStatusEnum.Created,
                name: "Created"
            }
        ],
        [
            "PendingAddendum",
            {
                value: HosPalTaskStatusEnum.PendingAddendum,
                name: "Pending Addendum"
            }
        ],
        [
            "ProcessingSubmission",
            {
                value: HosPalTaskStatusEnum.ProcessingSubmission,
                name: "Processing"
            }
        ],
        [
            "OrderReceived",
            {
                value: HosPalTaskStatusEnum.OrderReceived,
                name: "Order Received"
            }
        ],
        [
            "Errored",
            {
                value: HosPalTaskStatusEnum.Errored,
                name: " "
            }
        ],
        [
            "NotYetScheduled",
            {
                value: HosPalTaskStatusEnum.NotYetScheduled,
                name: "Not Yet Scheduled"
            }
        ]
    ]);
}

export const HosPalTaskStatus = new HosPalTaskStatusEnumClass();
